import responsiveRing from './geometry';

const preRenderResponsive = [{ name: 'responsiveRing', method: responsiveRing }];

export default {
  preRender: preRenderResponsive,
};
